import React, { useState, useEffect } from 'react';

// Coloca tu video en public/ con este nombre, o cambia la ruta aquí
const VIDEO_SRC = '/login-bg.mp4';
const POSTER_SRC = '/login-poster.webp';

const PHRASES = [
  {
    title: 'Operaciones inteligentes',
    sub: 'Gestiona todo tu equipo de atención desde un solo lugar, sin fricción.',
  },
  {
    title: 'Responde más rápido',
    sub: 'Centraliza WhatsApp, Instagram y Messenger en una sola bandeja unificada.',
  },
  {
    title: 'Decisiones con datos',
    sub: 'Métricas en tiempo real para que siempre sepas cómo va tu operación.',
  },
  {
    title: 'Automatiza lo repetitivo',
    sub: 'Deja que la IA gestione consultas frecuentes mientras tú atiendes lo que importa.',
  },
];

const AVATARS = [
  { color: '#6ee7b7', initials: 'MR' },
  { color: '#93c5fd', initials: 'LP' },
  { color: '#fcd34d', initials: 'CR' },
  { color: '#f9a8d4', initials: 'AS' },
];

export default function Login({ onLogin, onShowRegister }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [phraseIdx, setPhraseIdx] = useState(0);
  const [visible, setVisible]   = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setPhraseIdx(i => (i + 1) % PHRASES.length);
        setVisible(true);
      }, 450);
    }, 15000);
    return () => clearInterval(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://talku.online/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('talku_token', data.token);
        onLogin({ id: data.id, email: data.email, name: data.name, role: data.role, token: data.token });
      } else {
        setError('Correo o contraseña incorrectos');
      }
    } catch {
      setError('Error de conexión. Intenta de nuevo.');
    }
    setLoading(false);
  };

  const phrase = PHRASES[phraseIdx];

  return (
    <>
      <style>{`
        /* Inter loaded from index.html */

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .lk-screen {
          display: flex;
          height: 100vh;
          font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: #fff;
          overflow: hidden;
        }

        /* ── LEFT PANEL ──────────────────────────────── */
        .lk-left {
          width: 480px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: 48px 52px 36px;
          background: #fff;
          position: relative;
          z-index: 2;
          overflow-y: auto;
        }

        .lk-logo-wrap {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }

        .lk-logo-wrap img {
          height: 60px;
          width: auto;
          object-fit: contain;
          mix-blend-mode: multiply;
        }

        .lk-form-body {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .lk-headline {
          font-size: 26px;
          font-weight: 700;
          color: #0a0a0a;
          letter-spacing: -0.6px;
          line-height: 1.25;
          margin-top: 28px;
          margin-bottom: 6px;
        }

        .lk-sub {
          font-size: 13px;
          color: #9ca3af;
          margin-bottom: 28px;
          line-height: 1.5;
        }

        .lk-field-box {
          background: #f5f5f3;
          border-radius: 14px;
          padding: 18px 20px;
          display: flex;
          flex-direction: column;
          gap: 14px;
          margin-bottom: 16px;
        }

        .lk-field {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #fff;
          border: 1.5px solid #e8e8e6;
          border-radius: 10px;
          padding: 0 14px;
          height: 48px;
          transition: border-color 0.15s;
        }

        .lk-field:focus-within {
          border-color: #0a0a0a;
        }

        .lk-field svg {
          flex-shrink: 0;
          color: #9ca3af;
        }

        .lk-field input {
          flex: 1;
          border: none;
          outline: none;
          font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 13px;
          color: #0a0a0a;
          background: transparent;
        }

        .lk-field input::placeholder { color: #c4c4c4; }

        .lk-eye {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          color: #9ca3af;
          display: flex;
          align-items: center;
          line-height: 0;
        }

        .lk-btn-main {
          width: 100%;
          height: 50px;
          background: #0a0a0a;
          color: #fff;
          border: none;
          border-radius: 12px;
          font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.01em;
          transition: opacity 0.15s;
          margin-bottom: 12px;
        }

        .lk-btn-main:disabled { opacity: 0.6; cursor: not-allowed; }
        .lk-btn-main:hover:not(:disabled) { opacity: 0.88; }

        .lk-btn-google {
          width: 100%;
          height: 50px;
          background: #fff;
          color: #0a0a0a;
          border: 1.5px solid #e8e8e6;
          border-radius: 12px;
          font-family: 'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: background 0.15s;
          margin-bottom: 20px;
        }

        .lk-btn-google:hover { background: #f9f9f9; }

        .lk-register {
          text-align: center;
          font-size: 12.5px;
          color: #9ca3af;
          margin-bottom: 0;
        }

        .lk-register a {
          color: #0a0a0a;
          font-weight: 700;
          text-decoration: none;
        }

        .lk-register a:hover { text-decoration: underline; }

        .lk-error {
          font-size: 12px;
          color: #ef4444;
          margin-bottom: 10px;
          padding: 8px 12px;
          background: #fef2f2;
          border-radius: 8px;
          border: 1px solid #fecaca;
        }

        /* Social proof */
        .lk-social {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 20px;
          background: #f5f5f3;
          border-radius: 14px;
        }

        .lk-avatars {
          display: flex;
          flex-direction: row;
        }

        .lk-avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          border: 2.5px solid #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: 700;
          color: #0a0a0a;
          margin-left: -10px;
          flex-shrink: 0;
        }

        .lk-avatars .lk-avatar:first-child { margin-left: 0; }

        .lk-social-text {
          display: flex;
          flex-direction: column;
        }

        .lk-social-text strong {
          font-size: 12.5px;
          font-weight: 700;
          color: #0a0a0a;
        }

        .lk-social-text span {
          font-size: 11px;
          color: #9ca3af;
        }

        /* ── RIGHT PANEL (floating rounded glass) ────── */
        .lk-right {
          flex: 1;
          position: relative;
          overflow: hidden;
          margin: 24px 24px 24px 12px;
          border-radius: 30px;
          box-shadow:
            0 24px 60px -28px rgba(0, 0, 0, 0.30),
            inset 0 0 0 1px rgba(255, 255, 255, 0.10);
          isolation: isolate;
        }

        .lk-video {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Neutral legibility overlay — subtle darkening at the bottom only */
        .lk-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.42) 0%,
            rgba(0, 0, 0, 0.12) 34%,
            rgba(0, 0, 0, 0) 62%
          );
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 56px 56px 56px;
        }

        /* Subtle neutral liquid glass — clean, sober, premium */
        .lk-glass-card {
          position: relative;
          background: rgba(255, 255, 255, 0.10);
          backdrop-filter: blur(22px) saturate(1.05);
          -webkit-backdrop-filter: blur(22px) saturate(1.05);
          border: 1px solid rgba(255, 255, 255, 0.16);
          border-radius: 22px;
          padding: 28px 30px;
          max-width: 400px;
          box-shadow:
            0 18px 44px -24px rgba(0, 0, 0, 0.45),
            inset 0 1px 0 rgba(255, 255, 255, 0.22);
        }

        .lk-phrase-title {
          font-size: 25px;
          font-weight: 600;
          color: #fff;
          letter-spacing: -0.3px;
          line-height: 1.25;
          margin-bottom: 10px;
        }

        .lk-phrase-sub {
          font-size: 14px;
          color: rgba(255,255,255,0.65);
          line-height: 1.65;
        }

        .lk-phrase-enter {
          animation: phraseIn 0.45s ease forwards;
        }

        .lk-phrase-exit {
          animation: phraseOut 0.35s ease forwards;
        }

        @keyframes phraseIn {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @keyframes phraseOut {
          from { opacity: 1; transform: translateY(0); }
          to   { opacity: 0; transform: translateY(-10px); }
        }

        .lk-phrase-dots {
          display: flex;
          gap: 6px;
          margin-top: 20px;
        }

        .lk-phrase-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.25);
          transition: background 0.3s, width 0.3s;
        }

        .lk-phrase-dot.active {
          background: rgba(255, 255, 255, 0.90);
          width: 20px;
          border-radius: 3px;
        }

        /* ── RESPONSIVE ──────────────────────────────── */
        @media (max-width: 860px) {
          .lk-screen {
            flex-direction: column;
            height: auto;
            min-height: 100vh;
          }

          .lk-right {
            order: -1;
            height: 240px;
            flex: none;
            width: auto;
            margin: 14px 14px 4px 14px;
            border-radius: 26px;
          }

          .lk-left {
            width: 100%;
            padding: 36px 28px 32px;
          }

          .lk-overlay { padding: 28px 28px 32px; }
          .lk-glass-card { padding: 22px 24px; }
          .lk-phrase-title { font-size: 20px; }
        }
      `}</style>

      <div className="lk-screen">
        {/* ── LEFT: Form ── */}
        <div className="lk-left">
          {/* Logo */}
          <div className="lk-logo-wrap">
            <img src="/logo-talku.png" alt="Talku" />
          </div>

          <div className="lk-form-body">
            <h1 className="lk-headline">Bienvenido de vuelta a Talku</h1>
            <p className="lk-sub">Ingresa tus credenciales para continuar</p>

            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              {/* Inputs */}
              <div className="lk-field-box">
                {/* Email */}
                <div className="lk-field">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="3"/>
                    <path d="M2 7l10 7 10-7"/>
                  </svg>
                  <input
                    type="email"
                    placeholder="correo@empresa.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoComplete="email"
                  />
                </div>

                {/* Password */}
                <div className="lk-field">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  <input
                    type={showPass ? 'text' : 'password'}
                    placeholder="••••••••••"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="lk-eye"
                    onClick={() => setShowPass(v => !v)}
                    tabIndex={-1}
                  >
                    {showPass ? (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {error && <div className="lk-error">{error}</div>}

              <button type="submit" className="lk-btn-main" disabled={loading}>
                {loading ? 'Ingresando...' : 'Iniciar Sesión'}
              </button>
            </form>

            {/* Google */}
            <button className="lk-btn-google" type="button">
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continuar con Google
            </button>

            <p className="lk-register">
              ¿No tienes una cuenta?{' '}
              <a onClick={onShowRegister} style={{cursor:'pointer'}}>Regístrate</a>
            </p>
          </div>

          {/* Social proof */}
          <div className="lk-social">
            <div className="lk-avatars">
              {AVATARS.map((a, i) => (
                <div key={i} className="lk-avatar" style={{ background: a.color }}>
                  {a.initials}
                </div>
              ))}
            </div>
            <div className="lk-social-text">
              <strong>¡Únete a más de 20k usuarios!</strong>
              <span>Equipos que ya confían en Talku</span>
            </div>
          </div>
        </div>

        {/* ── RIGHT: Video + Glassmorphism ── */}
        <div className="lk-right">
          <video
            className="lk-video"
            src={VIDEO_SRC}
            poster={POSTER_SRC}
            preload="auto"
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="lk-overlay">
            <div className="lk-glass-card">
              <div className={`lk-phrase-title ${visible ? 'lk-phrase-enter' : 'lk-phrase-exit'}`}>
                {phrase.title}
              </div>
              <div className={`lk-phrase-sub ${visible ? 'lk-phrase-enter' : 'lk-phrase-exit'}`}
                   style={{ animationDelay: '0.06s' }}>
                {phrase.sub}
              </div>
              <div className="lk-phrase-dots">
                {PHRASES.map((_, i) => (
                  <div
                    key={i}
                    className={`lk-phrase-dot${i === phraseIdx ? ' active' : ''}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
